import React from 'react';
import Tooltip from '../../muiComponents/Tooltip';
import TextInput from '../../muiComponents/TextInput/TextInput';
import Icon from '../../muiComponents/Icon';

interface AccountInfoReadOnlyFieldProps {
    labelText: string;
    value: string;
    tooltipText: string;
}

const AccountInfoReadOnlyField = ({
    labelText,
    value,
    tooltipText,
}: AccountInfoReadOnlyFieldProps) => {
    return (
        <div className='position-relative'>
            <span
                className='position-absolute'
                style={{ top: 14, right: 6, zIndex: 400 }}
            >
                <Tooltip titleText={tooltipText}>
                    <span>
                        <Icon
                            iconName='InfoOutlined'
                            style={{
                                fontSize: '12px',
                                color: 'var(--grey-400)',
                                cursor: 'pointer',
                            }}
                        />
                    </span>
                </Tooltip>
            </span>
            <TextInput labelText={labelText} value={value} disabled />
        </div>
    );
};

export default AccountInfoReadOnlyField;
